import { Link } from 'react-router-dom'
import styles from './AlbumCard.module.css'

const AlbumCard = ({ album }) => {
  return (
    <Link
      to={`/music/${album.title}`}
      className={styles.albumCard}
    >
      <img
        className={styles.albumCover}
        src={album.image}
        alt='album cover'
      />
      <p>
        {album.title} - {album.type}
      </p>
      <p>{album.year}</p>
    </Link>
  )
}

export default AlbumCard
